import React, { useState, useEffect } from 'react'
import MyMedicine from '../assets/my-medicine.gif';
import 'animate.css';
import '../css/components/Home.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import Header from '../general/Header'
import Banner1 from '../assets/banner-2.png';
import CountUp from 'react-countup';
import Capsules from '../assets/tablets.jpg';
import Syrup from '../assets/syrup.jpg';
import Devices from '../assets/medical-device.jpg';
import Ointment from '../assets/gel.jpg';
import Units from '../assets/healthcare-unit.jpg';
import Supplements from '../assets/supplements.jpg';
import Copyright from '../general/Copyright';
import ResponseMsg from '../general/ResponseMsg';
import BottomBanner from '../general/BottomBanner';
import { useNavigate } from 'react-router-dom';
import BannerBg from '../assets/banner-bg.jpg';

const Home = ({ isUser, userData }) => {
  const [response, setResponse] = useState(null);
  const [cart, setCart] = useState([]);
  const [products, setProducts] = useState([]);
  const [offers, setOffers] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(`https://api.kcmstore.in/store/get-product`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id).slice(0, 30);
            setProducts(sortedProducts);
    

        } else {
          console.error('Failed to fetch products');
        }
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };


    if(userData != null){
                        const updateCartFromStorage = async () => {
        const response = await fetch(`https://api.kcmstore.in/store/get-mycart/${userData.id}`);
        if (response.ok) {
          const data = await response.json();
          const sortedProducts = data.sort((a, b) => b.id - a.id);
        setCart(sortedProducts || []);
        } else {
            setCart([]);
        }

        const savedCart = JSON.parse(localStorage.getItem('cart'));
        console.log(savedCart);
        // setCart(savedCart || []);
    };

    updateCartFromStorage();
}    fetchProducts();
    fetchOffers();
  }, []);

    const fetchOffers = async () => {
      try {
        const response = await fetch('https://api.kcmstore.in/store/get-offers');
        if (response.ok) {
          const data = await response.json();
          console.log(data);
          setOffers(data);
        } else {
          console.error('Failed to fetch offers');
        }
      } catch (error) {
        console.error('Error fetching offers:', error);
      }
    };


  const handleAddCart = async (product) => {
    if (!isUser) {
      setResponse('Login to your account first.');
      setTimeout(() => {
        setResponse('');
      }, 2000)
      return;
    }

    if (!userData.state) {
      setResponse('Update your address details in Profile.');
      setTimeout(() => {
        setResponse('');
      }, 2000)
      return;
    }

// if(product.subadmin_state  != userData.state){
//   setResponse('Delivery not available in your Area.');
//   setTimeout(() => {
//     setResponse('');
//   }, 2000)
//   return;
// }

    // if (!product || !product.medicine_id) {
    //   console.error('Invalid product data');
    //   setTimeout(() => {
    //     setResponse('');
    //   }, 2000)
    //   return;
    // }

    if (product.stock == '0') {
      setResponse('This product is currently out of stock.');
      setTimeout(() => {
        setResponse('');
      }, 2000)
      return;
    }

              if (product.added_pres == 'yes') {
      setResponse('Upload Medical Prescription to Order this Medicine.');
          navigate(`/medicine-details/${product.name}`, { state: { product } })
      setTimeout(() => setResponse(''), 3000);
      return;
    }

    setResponse('Product added to cart.');
    setTimeout(() => {
      setResponse('');
    }, 2000)

     try {
    const response = await fetch(`https://api.kcmstore.in/store/add-to-cart/${userData.id}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        prod_name: product.name,
        item_qty: 1,
      }),
    });

    const data = await response.json();

    if (response.ok) {
      console.log('✅ Cart synced with backend:', data);
    } else {
      console.error('❌ Failed to sync cart:', data.message || 'Unknown error');
    }
  } catch (error) {
    console.error('⚠️ Network error while syncing cart:', error);
  }
  navigate(`/medicine-details/${product.name}`, { state: { product } })
      window.dispatchEvent(new Event('cartUpdated'));

  };


  return (
    <>

      <Header isUser={isUser} userData={userData} />

<div id="carouselExampleIndicators" className="carousel slide" style={{ marginTop: '-5em' }} data-bs-ride="carousel">
    <div className="carousel-indicators">
        {offers.length > 0 &&
            offers.map((offer, index) => (
                <button
                    key={index}
                    type="button"
                    data-bs-target="#carouselExampleIndicators"
                    data-bs-slide-to={index}
                    className={index === 0 ? 'active' : ''}
                    aria-label={`Slide ${index + 1}`}
                ></button>
            ))
        }
    </div>

    <div className="carousel-inner">
        {offers.length > 0 ? (
            offers.map((offer, index) => {
                const offerUrl = `https://api.kcmstore.in/sUploads/${offer['image']}`;
                return (
                    <div
                        key={index}
                        className={`carousel-item ${index === 0 ? 'active' : ''} banner-bg`}
                        data-bs-interval="2000"
                        style={{ backgroundImage: `url(${offerUrl || BannerBg})` }}
                    >
                        <div className="container py-5">
                            <p className="fs-5 fw-semibold">{offer.offer_tagline}</p>
                            <p className="banner-heading col-lg-6 col-md-8">{offer.offer_name}</p>
                            <p className="col-lg-5 col-md-8 fw-semibold">{offer.description}</p>

{offer.description &&
                            <button
                                className="banner-btn mt-4 animate__animated animate__pulse animate__infinite"
                                onClick={() => {
                                    const element = document.getElementById("featured");
                                    if (element) {
                                        element.scrollIntoView({ behavior: "smooth" });
                                    }
                                }}
                            >
                                Shop Now
                            </button>
                            }
                        </div>
                    </div>
                );
            })
        ) : (
            <div className="carousel-item active banner-bg" style={{ backgroundImage: `url(${BannerBg})` }}>
                <div className="container py-5">
                    <p className="fs-5 fw-semibold">Get Medicines at your Doorstep</p>
                    <p className="banner-heading col-lg-6 col-md-8">KCM - Your Online Medical Buddy</p>
                    <p className="col-lg-5 col-md-8 fw-semibold">
                        We deliver a wide range of medicines directly to your doorstep, ensuring convenience and reliability. Your health is our top priority!
                    </p>
                    <button
                        className="banner-btn mt-4 animate__animated animate__pulse animate__infinite"
                        onClick={() => {
                            const element = document.getElementById("featured");
                            if (element) {
                                element.scrollIntoView({ behavior: "smooth" });
                            }
                        }}
                    >
                        Shop Now
                    </button>
                </div>
            </div>
        )}
    </div>
</div>

      {/* banner section ends */}


      {/* medical category banner section */}
      <section className='bg-light py-5'>
        <div className='container'>

          <div className='row'>

            <div className='col-lg-6 col-12 my-2'>
            <div className='medical-banner h-100'>
            <p className='medical-banner-heading'>Home Medical Supplies</p>
            <p className='sec-heading'>Exclusive Medical Kits</p>
            <p className='featured-price'>Starting From ₹10.0</p>
            <button className='login-btn2 mt-4 text-capitalize rounded-pill'>Shop Now</button>
            <img src={Banner1} className='medical-banner-img' alt='medical banner' />
              </div>
              </div>

            <div className='col-lg-6 col-12 my-2'>
              <div className='banner2-bg h-100 align-content-center'>

                    <div className='d-flex my-2'>
                      <i class="fa-solid fa-stethoscope my-3 fs-2  me-5"></i>
                      <div>
                        <p className='medical-banner-heading mb-0'>Medical Supplies Covered</p>
                        <span className='counter-num'><CountUp end={90} duration={4} enableScrollSpy={true} />%</span></div>
                    </div>

                    <div className='d-flex my-2'>
                      <i class="fa-solid fa-star my-3 fs-2  me-5"></i>
                      <div>
                        <p className='medical-banner-heading mb-0'>Years Serving People</p>
                        <span className='counter-num'><CountUp end={10} duration={4} enableScrollSpy={true} />+</span></div>
                    </div>

                    <div className='d-flex my-2'>
                      <i class="fa-solid fa-tags my-3 fs-2  me-5"></i>
                      <div>
                        <p className='medical-banner-heading mb-0'>Affordable Rates</p>
                        <span className='counter-num'><CountUp end={100} duration={4} enableScrollSpy={true} />%</span></div>
                    </div>


              </div>
            </div>

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* medical category banner section ends */}



{/* Values section */}
<section className='bg-light py-4'>
  <div className='container'>

<div className='row'>

  <div className='col-lg-3 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-wallet medical-icon my-3 me-3"></i>
    <div>
    <p className='fs-5 fw-bold mb-0'>Secure Payment</p>
  <p className='medical-banner-heading'>Easy Payment Options</p></div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-ranking-star medical-icon my-3 me-3"></i>
    <div>
  <p className='fs-5 fw-bold mb-0'>Quality Product</p>
  <p className='medical-banner-heading'>Unmatched Medicine Quality</p>    </div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-piggy-bank medical-icon my-3 me-3"></i>
    <div>
  <p className='fs-5 fw-bold mb-0'>Big Savings</p>
  <p className='medical-banner-heading'>Get Great Discounts</p></div>
  </div>

  <div className='col-lg-3 col-md-6 col-12 my-2 d-flex'>
  <i class="fa-solid fa-truck-fast medical-icon my-3 me-3"></i>
    <div>
  <p className='fs-5 fw-bold mb-0'>Free Shipping</p>
  <p className='medical-banner-heading'>On All Orders</p></div>
  </div>


</div>
{/* row ends */}

  </div>
</section>
{/* Values section ends */}


      {/* Featured Product range */}
      <section className='bg-light py-4' id="featured">
        <div className='container'>

          <p className='sec-heading my-0'>Featured Products</p>

          <div className='row'>

            {products.length > 0 ? (
              products.slice(0, 8).map((product) => {
                const existingCart = cart || [];
const productIndex = existingCart.findIndex(
  item => item.prod_name.toLowerCase() === product.name.toLowerCase()
);                const isInCart = productIndex !== -1;

                return (
                  <div className='col-lg-3 col-md-6 col-6 my-2'>
                    <div className='featured-area'>
                      <div onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>
                      <div className='featured-btn-area d-block bg-transparent'>
                        <p className='text-muted fw-semibold bg-light px-2 py-1 rounded'>
                          {product.stock == '0' ? 'Out of Stock' : ''}
                        </p>
                      </div>

                      <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid' alt='Product' />
                      <p className='featured-category'>{product.unit}</p>
                      <p className='featured-name cursor-pointer'>{product.name}</p>
                      <p className='featured-price d-flex justify-content-center'>₹ {product.sell_price}{product.discount_amount > 0 && (
                        <p className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                          {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'}  Off
                        </p>
                      )}</p>
                      </div>
                      {isInCart ?
                        <button
                          className='add-to-cart w-100 bg-dark text-white'  onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>Added to Cart</button>
                        : <button
                          className='add-to-cart w-100'
                          onClick={() => handleAddCart(product)}
                          disabled={product.stock === '0'}
                        >+ Cart</button>}
                    </div>
                  </div>
                );
              })
            ) : (
              <div className='text-center my-4'>
                <img src={MyMedicine} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                <p className='fw-bold'>No Medicine available in your Area.</p>
              </div>
            )}

          </div>
          {/* row ends */}

        </div>
      </section>
      {/* Featured Product range ends */}


      {/* categories section */}
      <section className='my-5'>
        <div className='container'>

          <div className='row justify-content-between text-center'>

            <div className='col-lg-2 col-md-4 col-sm-4 col-4 my-2'>
              <img src={Capsules} className='img-fluid category-img' alt='category' />
              <p className='category-text'>Capsules/ Tablets</p>
            </div>

            <div className='col-lg-2 col-md-4 col-sm-4 col-4 my-2'>
              <img src={Syrup} className='img-fluid category-img' alt='category' />
              <p className='category-text'>Syrup/ Drinks</p>
            </div>

            <div className='col-lg-2 col-md-4 col-sm-4 col-4 my-2'>
              <img src={Devices} className='img-fluid category-img' alt='category' />
              <p className='category-text'>Medical Devices</p>
            </div>

            <div className='col-lg-2 col-md-4 col-sm-4 col-4 my-2'>
              <img src={Ointment} className='img-fluid category-img' alt='category' />
              <p className='category-text'>Gel/ Ointment</p>
            </div>


            <div className='col-lg-2 col-md-4 col-sm-4 col-4 my-2'>
              <img src={Units} className='img-fluid category-img' alt='category' />
              <p className='category-text'>Healthcare Unit</p>
            </div>

            <div className='col-lg-2 col-md-4 col-sm-4 col-4 my-2'>
              <img src={Supplements} className='img-fluid category-img' alt='category' />
              <p className='category-text'>Other Supplements</p>
            </div>


          </div>
          {/* row ends */}

        </div>
      </section>
      {/* categories section ends */}


      {/* Exclusive Product range */}
      <section className='my-5'>
        <div className='container'>

          <div className='d-flex justify-content-between'>
            <p className='sec-heading'>Latest Exclusive Range</p>

            <div className='align-content-center'>
              <span className="swiper-button-prev mx-1"><i class="fa-solid fa-angle-left"></i></span>
              <span className="swiper-button-next mx-1"><i class="fa-solid fa-angle-right"></i></span>
              <button className='login-btn px-0 ms-lg-4 ms-md-4 ms-1 py-0 mt-2 text-capitalize' onClick={() => navigate('/shop')}>View All</button>
            </div>

          </div>

          <Swiper spaceBetween={20} slidesPerView={4} modules={[Autoplay, Navigation]} loop={true}
            navigation={{ nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' }} autoplay={{ delay: 2000 }}
            breakpoints={{
              0: {
                slidesPerView: 2,
              },
              768: {
                slidesPerView: 2,
              },
              992: {
                slidesPerView: 4,
              }
            }}>


            {products.length > 0 ? (
              products.slice(0, 12).map((product) => {
                // const existingCart = JSON.parse(localStorage.getItem('cart')) || [];
                const existingCart = cart || [];
                // const productIndex = existingCart.findIndex(item => item.medicine_id === product.medicine_id);
const productIndex = existingCart.findIndex(
  item => item.prod_name.toLowerCase() === product.name.toLowerCase()
);                const isInCart = productIndex !== -1;

                return (
                  <SwiperSlide className='my-2'>
                    <div className='featured-area'>
                      <div onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>
                      <div className='featured-btn-area d-block bg-transparent'>
                        <p className='text-muted fw-semibold bg-light px-2 py-1 rounded'>
                          {product.stock == '0' ? 'Out of Stock' : ''}
                        </p>
                      </div>

                      <img src={`https://api.kcmstore.in/sUploads/${product.image.split(',')[0]}`} className='img-fluid' alt='Product' />
                      <p className='featured-category'>{product.unit}</p>
                      <p className='featured-name cursor-pointer'>{product.name}</p>
                      <p className='featured-price d-flex justify-content-center'>₹ {product.sell_price}{product.discount_amount > 0 && (
                        <p className='text-start ps-2 text-muted fw-semibold fs-6 my-0'>
                          {product.discount_amount}{product.discount_type === 'percent' ? '%' : '₹'}  Off
                        </p>
                      )}</p>
                      </div>
                      {isInCart ?
                        <button
                          className='add-to-cart w-100 bg-dark text-white'  onClick={() => navigate(`/medicine-details/${product.name}`, { state: { product } })}>Added to Cart</button>
                        : <button
                          className='add-to-cart w-100'
                          onClick={() => handleAddCart(product)}
                          disabled={product.stock === '0'}
                        >+ Cart</button>}
                    </div>
                  </SwiperSlide>
                );
              })
            ) : (
              <div className='text-center'>
                <img src={MyMedicine} className='img-fluid col-lg-4 col-md-6 col-sm-6 col-10' alt='Staff' />
                <p className='fw-bold'>No Medicine available in your Area.</p>
              </div>
            )}

          </Swiper>

        </div>
      </section>
      {/* Exclusive Product range ends */}


      <BottomBanner />

      {!isUser && <Copyright />}

      {response && <ResponseMsg message={response} />}

    </>
  )
}

export default Home
